import fetch,{postFrom,getBlob} from '../utils/fetch';

export function conditionForList() {
  return fetch({
    method: 'GET',
    url: '/reservation/order/conditionForList'
  })
}

export function getbankInfo() {
  return fetch({
    method: 'GET',
    url: 'financebaseinfo/getbankInfo'
  })
}


export function orderlist(params) {
  return fetch({
    method: 'POST',
    url: '/reservation/order/list',
    data:params
  })
}

export function orderclose(params) {
  return fetch({
    method: 'POST',
    url: '/reservation/order/close',
    params
  })
}

export function invalidDetail(fid) {
  return fetch({
    method: 'GET',
    url: '/reservation/order/invalidDetail',
    params:{
      fid
    }
  })
}

export function orderinvalid(params) {
  return fetch({
    method: 'POST',
    url: '/reservation/order/invalid',
    data:params
  })
}

export function roomCanReservation(params) {
  return postFrom('/reservation/order/roomCanReservation',params)

}
export function saveReservation(params) {
  return fetch({
    method: 'POST',
    url: '/reservation/order/saveReservation',
    data:params
  })
}

export function getBillNum(reservationId) {
  return fetch({
    method: 'GET',
    url: '/reservation/order/getBillNum',
    params:{
      reservationId
    }
  })
}

export function reservationToSignInit(params) {
  return fetch({
    method: 'POST',
    url: '/reservation/order/reservationToSignInit',
    params
  })
}

export function updateReservationToSign(param) {
  return fetch({
    method: 'POST',
    url: '/reservation/order/updateReservationToSign',
    data:param
  })
}

export function reservationSubject(reservationId) {
  return fetch({
    method: 'GET',
    url: '/reservation/order/subject',
    params:{
      reservationId
    }
  })
}

export function getReservationDetail(reservationId) {
  return fetch({
    method: 'GET',
    url: '/reservation/order/detail',
    params:
      reservationId

  })
}

export function getReservationBills(reservationId) {
  return fetch({
    method: 'GET',
    url: '/reservation/order/bills',
    params:
    reservationId

  })
}
  export function getReservationText(reservationId) {
    return fetch({
      method: 'GET',
      url: '/reservation/order/getReservationText',
      params:
      reservationId

    })
  }

export function repayment(busId) {
  return fetch({
    method: 'GET',
    url: '/reservation/order/repayment',
    params:
      busId
  })
}
export function refund(paymentFid) {
  return fetch({
    method: 'GET',
    url: '/reservation/order/refund',
    params:
      paymentFid
  })
}


